import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { fetchStickerPacks } from "../../../actions/sticker_maker/stickerPacksActions";
import { fetchCategories } from "../../../actions/sticker_maker/categoriesActions";
import { useAppDispatch } from "../../../store/hooks";
import { queryParams } from "../../../helpers/UrlHelpers";
import stickerMakerUrls from "../../../configs/sticker_maker/stickerMakerUrls";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "../StickerPacks/_partials/_PageHeader";
import List from "../StickerPacks/_partials/_List";
import Wrapper from "../../../componets/Wrapper";
import Filter, { FilterInterface } from "../../../componets/Filter";
import MenuTags from "../Categories/_partials/_MenuTags";
import NewCategory from "../Categories/New";
import EditCategory from "../Categories/Edit";
import CategoriesSettings from "../Categories/Settings";
import ListViewButtons from "../../../componets/ListViewButtons";

interface PropsInterface {
  collection?: 'recents' | 'trending' | 'popular';
}

const NAV_ITEMS: {[index: number]: any} = {
  1: {
    id: 1,
    name: 'Popular',
    url: stickerMakerUrls.communityPopularPath()
  },
  2: {
    id: 2,
    name: 'Trending',
    url: stickerMakerUrls.communityTrendingPath()
  },
  3: {
    id: 3,
    name: 'Recents',
    url: stickerMakerUrls.communityRecentsPath()
  },
};

const LIMIT = 42;
const DEFAULT_VIEW = 'grid';

const Community = ({ collection }: PropsInterface) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const categoryIds     = queryParams.get(searchParams,'category_ids');
  const pagination      = !collection || collection === 'recents';
  const listType: any   = queryParams.get(searchParams,'view') || DEFAULT_VIEW;
  const filterProps: FilterInterface = {};

  useEffect(() => {
    dispatch(fetchCategories({ target: 1 }));
  }, [dispatch]);

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (categoryIds) {
      params.category_ids = categoryIds?.split(',') || [];
    }

    dispatch(fetchStickerPacks({ params, target: 'community', collection }));
  }, [categoryIds, collection, searchParams, currentPage, dispatch]);

  if (!collection) {
    filterProps.orderBy = {
      defaultKey: 'id',
      defaultSort: 'desc',
      items: [
        { name: 'Date', key: 'id' },
        { name: 'Popular', key: 'popular_count' },
        { name: 'Likes', key: 'likes_count' },
        { name: 'Stickers', key: 'stickers_count' },
      ]
    };
  }

  return (
    <PageLayout>
      <PageHeader
        title={'Community'}
        navs={NAV_ITEMS}
        parent={{
          name: 'All',
          url: stickerMakerUrls.communityPath()
        }}
      />

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            search
            dateRange
            {...filterProps}
          >
            <ListViewButtons align='right' defaultType={DEFAULT_VIEW} />
            <MenuTags />
          </Filter>
        </Wrapper>

        <List limit={LIMIT} pagination={pagination} type={listType} />

        <NewCategory />
        <EditCategory />
        <CategoriesSettings />
      </div>
    </PageLayout>
  );
}

export default Community;
